"use client";
import React from "react";
import { motion } from "framer-motion";
import Header from "./Header";
import HeroSection from "./HeroSection";
import SignatureSection from "./SignatureSection";
import ServicesSection from "./ServicesSection";
import MenuSection from "./MenuSection";
import TestimonialsSection from "./TestimonialsSection";
import Footer from "./Footer";

const BakeryLanding = () => {
  return (
    <motion.div
      className=""
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      <div className="overflow-hidden bg-white max-md:max-w-full">
        <Header />
        <div className="flex flex-col w-full max-md:max-w-full">
          <HeroSection />
          <SignatureSection />
          <ServicesSection />
          <MenuSection />
          <TestimonialsSection />
          <Footer />
        </div>
      </div>
    </motion.div>
  );
};

export default BakeryLanding;
